import Login from '../pages/Authentication/Login';
import { ROUTES } from '@/configs/routesConfig';

import { lazy } from 'react';
const PsychologistsPage = lazy(() => import('@/pages/Admin/PsychologistsPage.js'));
const SchedulerPage = lazy(() => import('@/pages/Psychologist/Scheduler/SchedulerPage.js'));
const ConsultationsPage = lazy(() => import('@/pages/ConsultationsPage.js'));
const ConsultationPage = lazy(() => import('@/pages/ConsultationPage.js'));
const UsersPage = lazy(() => import('@/pages/UsersPage.js'));
const UserPage = lazy(() => import('@/pages/UserPage.js'));
const ZoomPage = lazy(() => import('@/pages/ZoomPage.js'));
const PsychologistProfilePage = lazy(() => import('@/pages/PsychologistProfilePage.js'));
const BlogPage = lazy(() => import('@/pages/BlogPage.js'));
const CheckoutsPage = lazy(() => import('@/pages/CheckoutsPage.js'));
const PagesPage = lazy(() => import('@/pages/PagesPage.js'));
const SinglePage = lazy(() => import('@/pages/SinglePage.js'));
const CallbacksPage = lazy(() => import('@/pages/CallbacksPage.js'));
const FeedbacksPage = lazy(() => import('@/pages/FeedbacksPage.js'));
const OfflineCentersPage = lazy(() => import('@/pages/OfflineCentersPage.js'));
const ProblemsPage = lazy(() => import('@/pages/ProblemsPage.js'));
const PromosPage = lazy(() => import('@/pages/PromosPage.js'));
const FiltersPage = lazy(() => import('@/pages/FiltersPage.js'));
const AgoraPage = lazy(() => import('@/pages/Agora/AgoraPage.js'));
const SeoPage = lazy(() => import('@/pages/SeoPage.js'));
const SingleSeoPage = lazy(() => import('@/pages/SingleSeoPage.js'));
const FeaturesPage = lazy(() => import('@/pages/FeaturesPage.js'));
const BannersPage = lazy(() => import('@/pages/BannersPage.js'));
const NutritionistsPage = lazy(() => import('@/pages/Admin/NutritionistsPage.js'));
const NutritionistProfilePage = lazy(() => import('@/pages/NutritionistProfilePage.js'));
const NutritionConsultationsPage = lazy(() => import('@/pages/NutritionConsultationsPage.js'));
const NutritionConsultationPage = lazy(() => import('@/pages/NutritionConsultationPage.js'));
const NutritionFeedbacksPage = lazy(() => import('@/pages/NutritionFeedbacksPage.js'));
const NutritionFiltersPage = lazy(() => import('@/pages/NutritionFiltersPage.js'));
const NutritionFeaturesPage = lazy(() => import('@/pages/NutritionFeaturesPage.js'));
const NutritionAgoraPage = lazy(() => import('@/pages/Agora/NutritionAgoraPage.js'));


const all = [
  { path: '/',                                          component: ConsultationsPage },
  { path: ROUTES.psychologists,                         component: PsychologistsPage },
  { path: `${ROUTES.psychologists}/:id`,                component: PsychologistProfilePage },
  { path: ROUTES.consultations,                         component: ConsultationsPage },
  { path: `${ROUTES.consultations}/:id`,                component: ConsultationPage },
  { path: `${ROUTES.consultations}/:id/zoom`,           component: ZoomPage },
  { path: `${ROUTES.consultations}/:id/agora`,          component: AgoraPage },
  { path: ROUTES.users,                                 component: UsersPage },
  { path: `${ROUTES.users}/:id`,                        component: UserPage },
  { path: ROUTES.pages,                                 component: PagesPage },
  { path: ROUTES.singlePageCreate(),                    component: SinglePage },
  { path: `${ROUTES.pages}/:id`,                        component: SinglePage },
  { path: ROUTES.scheduler,                             component: SchedulerPage },
];

const adminRoutes = [
  ...all,
  { path: '/blog',                                      component: BlogPage },
  { path: ROUTES.checkouts,                             component: CheckoutsPage },
  { path: ROUTES.feedbacks,                             component: FeedbacksPage },
  { path: ROUTES.callbacks,                             component: CallbacksPage },
  { path: ROUTES.centers,                               component: OfflineCentersPage },
  { path: ROUTES.problems,                              component: ProblemsPage },
  { path: ROUTES.promos,                                component: PromosPage },
  { path: ROUTES.filters,                               component: FiltersPage },
  { path: ROUTES.seo,                                   component: SeoPage },
  { path: ROUTES.features,                              component: FeaturesPage },
  { path: `${ROUTES.seo}/:slug`,                        component: SingleSeoPage },
  { path: ROUTES.singleSeoPageCreate,                   component: SingleSeoPage },
  { path: ROUTES.banners,                               component: BannersPage },
  { path: ROUTES.nutritionists,                         component: NutritionistsPage },
  { path: `${ROUTES.nutritionists}/:id`,                component: NutritionistProfilePage },
  { path: ROUTES.nutritionConsultations,                component: NutritionConsultationsPage },
  { path: `${ROUTES.nutritionConsultations}/:id`,       component: NutritionConsultationPage },
  { path: `${ROUTES.nutritionConsultations}/:id/agora`, component: NutritionAgoraPage },
  { path: ROUTES.nutritionFeedbacks,                    component: NutritionFeedbacksPage },
  { path: ROUTES.nutritionFilters,                      component: NutritionFiltersPage },
  { path: ROUTES.nutritionFeatures,                     component: NutritionFeaturesPage },
];

const psychologistRoutes = [
  ...all,
  { path: ROUTES.nutritionConsultations,                component: NutritionConsultationsPage },
  { path: `${ROUTES.nutritionConsultations}/:id`,       component: NutritionConsultationPage },
  { path: `${ROUTES.nutritionConsultations}/:id/agora`, component: NutritionAgoraPage },
];

const publicRoutes = [{ path: ROUTES.login, component: Login }];

export { adminRoutes, psychologistRoutes, publicRoutes };
